import router from '@/router'
import { can } from '@/lib/can'

export type AbsolutePath = `/${string}`
// {スタック状態のURL}: https://localhost:5173/project//project/project------00000014
// {相対パス}: project_sales/456
// {予期しないパス}: /project/project_sales/456

// vue-stacked-uiで{スタック状態のURL}から{相対パス}でpath.resolveですると、
// {予期しないルート}にRouteが返ってきて権限チェックが正しく動作しない。
// そのため、常に絶対パスを要求する。
export async function canRoute(url: AbsolutePath): Promise<boolean> {
  try {
    const resolved = router.resolve(url)
    const meta = resolved.meta

    // canRouteを使って、metaが無い場合は実装ミスの可能性が高いため、拒否する
    if (meta === undefined || meta.action === undefined || meta.subject === undefined) {
      console.warn(`Route ${url} is missing required meta properties (action/subject)`)
      return false
    }

    return await can(meta.action, meta.subject, resolved.params)
  } catch (error) {
    console.error(`Failed to resolve route: ${url}`, error)
    return false
  }
}
